"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordLogin = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var password_1 = require("../../model/password");
var service_1 = require("../../../library/base/service");
var ResetPasswordLogin = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ResetPasswordLogin, _super);
    function ResetPasswordLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '重置登录密码接口';
        _this.code = '101014';
        _this.desc = '重置登录密码接口';
        _this.requestParams = new password_1.ResetPasswordLoginRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ResetPasswordLogin;
}(service_1.BaseService));
exports.ResetPasswordLogin = ResetPasswordLogin;
//# sourceMappingURL=resetPasswordLogin.js.map